export default {
  setPageLoading: 'app/setPageLoading',
};
